<template>
  <div class="agenda-task-control">
    <div class="agenda-row" v-for="row in calendar.rows">
      <user-column :row="row"></user-column>

      <div class="agenda-col" v-for="col in row.columns">

        <draggable v-model="col.tasks"
                   :user_id="row.user.id"
                   :date="col.date"
                   class="dragArea"
                   :options="{ghostClass: 'ghost', group: {name: 'tasks'}, draggable: !screenSm ? '.draggable' : ''}"
                   @add="taskUpdated"
                   @end="taskDragEnd"
        >
          <div class="task draggable"
               :class="{'done': task.is_done, 'project_billed': task.project.is_billed, 'selected': task.selected}"
               v-for="task in col.tasks"
               :task_id="task.id"
               @click="showTask(task.id, row, col)">
            <div class="flex">
              <div class="client-name subheading flex-grow-1" :class="{'color-orange-sun': task.type == 'internal'}">{{ task.client.name }}</div>
              <div class="client-name subheading flex-grow-1">&nbsp;</div>
              <div class="color-gray-500">{{ task.is_done ? (task.engineering_hours_formatted || '0:00') + " / " : null }} {{ task.duration_formatted || '00:00' }}</div>
            </div>
            <div class="color-gray-800 font-weight-bold project-name" v-if="task.type == 'client'">{{ task.project.name }}</div>
            <div class="color-gray-500 name">{{ task.name }}</div>
            <div v-show="task && task.project && $root.canEditBilledProjects(task.project.is_billed, false)" class="task-select-button" @click.stop="toggleTaskSelect(task)">
              <i class="fas fa-check"></i>
            </div>
          </div>
        </draggable>

        <div class="footer">
          <div class="add-task-button" @click="addTask(row, col)">+ Add task</div>
          <div class="hours">{{ col.time_used_visual }} / 8 hrs</div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import UserColumn from './user-column'
import TaskSelector from "../TaskSelector";

export default {
  components: {
    draggable,
    UserColumn,
  },
  created() {
    new TaskSelector(this.$root)

    this.$root.$on('Calendar::load-users', (rows) => this.loadUsers(rows))

    this.$root.$on('Tasks::deleted', ({task}) => {
      if (task.user_id && task.date) {
        this.removeTaskFromCalendar(task.id, task.user_id, task.date)
      }
    })
    this.$root.$on('Tasks::created', ({task}) => {
      if (task.user_id) {
        this.injectTaskIntoCalendar(task)
      }
    })
    this.$root.$on('Tasks::updated', ({task}) => {
      if (task.user_id) {
        this.updateTask(task)
      }
    })
    this.$root.$on('Projects::deleted', ({project}) => {
      _.each(this.calendar.rows, row => {
        _.each(row.columns, column => {
          _.each(column.tasks, task => {
            if (task.project_id === project.id) {
              this.$root.$emit('Tasks::deleted', {task})
            }
          })
        })
      })
    })
  },
  mounted() {
    let menuHeight = this.getElementHeight('menu')
    let headerHeight = this.getElementHeight('agenda-header')
    let header2Height = this.getElementHeight('header2')

    document.getElementsByClassName('agenda-task-control')[0].style['max-height'] = "calc(100vh - " + (menuHeight + headerHeight + header2Height) + "px)"
  },
  data() {
    return {
      screenSm: false,
      calendar: {
        rows: [],
      },
    }
  },
  methods: {
    getElementHeight(_class) {
      let el = document.getElementsByClassName(_class)[0]

      let elHeight = el.offsetHeight
      elHeight += parseInt(window.getComputedStyle(el).getPropertyValue('margin-top'))
      elHeight += parseInt(window.getComputedStyle(el).getPropertyValue('padding-top'))
      elHeight += parseInt(window.getComputedStyle(el).getPropertyValue('margin-bottom'))
      elHeight += parseInt(window.getComputedStyle(el).getPropertyValue('padding-bottom'))

      return elHeight
    },
    findTaskById(id) {
      let t = null

      _.each(this.calendar.rows, row => {
        _.each(row.columns, column => {
          _.each(column.tasks, task => {
            if (task.id === id) {
              t = task
            }
          })
        })
      })

      return t
    },
    showTask(task_id, row, col) {
      this.$root.$emit('SmallTaskModal::show', {task_id, row, col})
    },
    loadUsers(rows) {
      this.calendar.rows = rows
      this.$forceUpdate()
    },
    addTask(row, col) {
      this.$root.$emit('TaskModal::create-task', {row, col})
    },
    taskDragEnd(event) {
      let from = event.from
      let to = event.to

      let fromUserId = from.getAttribute('user_id')
      let fromDate = from.getAttribute('date')
      let user_id = to.getAttribute('user_id')
      let date = to.getAttribute('date')
      if (fromDate == date && fromUserId == user_id) {

        let row = _.find(this.calendar.rows, row => row.user.id === parseInt(user_id))
        let column = _.find(row.columns, column => moment(column.date).isSame(moment(date), 'day'))
        console.log(_.map(column.tasks, t => t.id))

      }
    },
    taskUpdated(event) {
      let from = event.from
      let to = event.to
      let item = event.item

      let fromUserId = from.getAttribute('user_id')
      let fromDate = from.getAttribute('date')
      let user_id = to.getAttribute('user_id')
      let date = to.getAttribute('date')
      let task_id = item._underlying_vm_.id
      let fromTaskPool = item.getAttribute('from_task_pool') || false

      if (!fromTaskPool) {
        this.axios.post('n/tasks/move', {
          task_id,
          user_id,
          date,
        }).then(response => {
          this.updateColumnTimeUsed(this.getColumn({user_id: fromUserId, date: fromDate}))
          this.updateColumnTimeUsed(this.getColumn({user_id, date}))
        }).catch(err => {
          console.log(err)
        })
      }

      if (fromTaskPool) {
        this.axios.post('n/tasks/add-from-task-pool', {
          task_id,
          user_id,
          date,
        }).then(response => {
          this.injectTaskIntoCalendar(response.data.data)
          this.removeTaskFromCalendar(task_id, user_id, date)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    //data = {user_id, date}
    getColumn(data) {
      let row = _.find(this.calendar.rows, row => row.user.id === parseInt(data.user_id))
      let column = _.find(row.columns, column => moment(column.date).isSame(moment(data.date), 'day'))
      return column
    },
    injectTaskIntoCalendar(task) {
      let column = this.getColumn(task)
      column.tasks.push(task)
      this.updateColumnTimeUsed(column)
      this.$root.$emit('ProjectView::reload')
    },
    removeTaskFromCalendar(task_id, user_id, date) {
      let column = this.getColumn({user_id, date})
      column.tasks = _.reject(column.tasks, task => task.id == task_id)
      this.updateColumnTimeUsed(column)
    },
    toggleTaskSelect(task) {
      let selected = task.selected ? false : true

      if (!selected) {
        this.$root.$emit('TaskSelector::deselect', task)
      }
      if (selected) {
        this.$root.$emit('TaskSelector::select', task)
      }
    },
    updateTask(task_data) {
      let row = _.find(this.calendar.rows, row => row.user.id === parseInt(task_data.user_id))
      let column = _.find(row.columns, column => moment(column.date).isSame(moment(task_data.date), 'day'))
      if (column) {
        let task = _.find(column.tasks, task => task.id === task_data.id)
        _.each(task, (value, key) => {
          this.$root.$set(task, key, task_data[key] !== undefined ? task_data[key] : task[key])
        })
        this.updateColumnTimeUsed(column)
      }
    },
    updateColumnTimeUsed(column) {
      let totalTime = 0
      _.each(column.tasks, t => totalTime += t.is_done ? t.engineering_hours : t.duration)
      column.time_left = (8 * 60 * 60) - totalTime
      column.time_left_visual = this.$root.formatIntegerSecondsToReadable(column.time_left)
      column.time_used = totalTime
      column.time_used_visual = this.$root.formatIntegerSecondsToReadable(column.time_used)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/calendar/calendar.vue